import React, {Component,} from 'react'

class CCCrashMe extends Component {
    constructor(props) {
        super(props);
        this.state = {error: false}
    }

    onClick() {
        this.setState({error: true})
    }

    render() {
        if(this.state.error) {
            throw new Error("Got error");
        }
        return (
            <button onClick={() => this.onClick()}>Crash me</button>
        )
    }
}

export default CCCrashMe;


// WEBPACK FOOTER //
// ./src/app/components/CCCrashMe/CCCrashMe.js